import {Component, forwardRef, Input, OnDestroy, OnInit} from '@angular/core';
import {ControlValueAccessor, FormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule} from "@angular/forms";
import {Subscription} from "rxjs";
import {NgIf, NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-textarea',
  standalone: true,
  imports: [
    FormsModule,
    NgIf,
    NgOptimizedImage,
    ReactiveFormsModule
  ],
  templateUrl: './textarea.component.html',
  styleUrl: './textarea.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextareaComponent),
      multi: true
    }
  ],
})
export class TextareaComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() public placeholder: string = '';
  public control = new FormControl();
  public onChange: (value: string) => void = () => {};
  public onTouched: () => void = () => {};
  private subscriptions: Subscription[] = [];

  constructor() {
  }

  ngOnInit() {
    this.subscriptions.push(
      this.control.valueChanges.subscribe(value => {
        this.onChange(value);
        this.onTouched();
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  writeValue(value: string): void {
    this.control.setValue(value);
  }
}
